import { dateToString } from 'helpers/date';

// Check if object is empty
export const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

// Get field of objects and arrays
export const fetchFromObject = (obj, prop) => {
  if (typeof obj === 'undefined' || obj === null) return false;
  const index = prop.indexOf('.');
  if (index > -1) {
    return fetchFromObject(obj[prop.substring(0, index)], prop.substr(index + 1));
  }
  return obj[prop];
};

// Set value in field at objects and arrays
export const setValueObjectByField = (obj, prop, value) => {
  if (typeof obj !== 'undefined') {
    const index = prop.indexOf('.');
    if (index > -1) {
      setValueObjectByField(obj[prop.substring(0, index)], prop.substr(index + 1), value);
    } else {
      // eslint-disable-next-line no-param-reassign
      obj[prop] = value;
    }
  }
};

export const mapArraryMasterData = data =>
  data.map(item => ({ label: item.label, value: item.value }));

export const checkIncludeArray = (includeMe, needInclusions) => {
  let someFlag = true;
  for (let i = 0; i < needInclusions.length; i += 1) {
    if (includeMe.indexOf(needInclusions[i]) === -1) {
      someFlag = false;
      break;
    }
  }
  return someFlag;
};

export const mapArrayCampaignData = campaign => {
  const objFormat = {};
  objFormat.value = campaign.campaignDetail;
  objFormat.contractValue = {};
  objFormat.contractValue.tableServices = campaign.tableServices;
  objFormat.contractValue.serviceList = campaign.serviceList;
  objFormat.campaignId = campaign.campaignId;
  objFormat.saleId = campaign.saleId;
  objFormat.idTemplate = campaign.idTemplate;
  objFormat.flow = campaign.flow;
  objFormat.campaignType = campaign.campaignType;
  objFormat.campaignName = campaign.campaignName;
  objFormat.toDate = dateToString(campaign.toDate);
  objFormat.toDateInvisibility = dateToString(campaign.toDateInvisibility);
  objFormat.email = campaign.campaignDetail.email;
  objFormat.monthFee = campaign.campaignDetail.monthFee;
  objFormat.monthFeeWithoutTaxes = campaign.campaignDetail.monthFeeWithoutTaxes;
  objFormat.vehicle = campaign.campaignDetail.vehicle;
  objFormat.accessories = campaign.campaignDetail.accessories;
  objFormat.termInMonths = campaign.campaignDetail.termInMonths;
  objFormat.yearKms = campaign.campaignDetail.yearKms;
  objFormat.rangeKms = campaign.campaignDetail.rangeKms;
  objFormat.downPayment = campaign.campaignDetail.downPayment;
  objFormat.make = campaign.campaignDetail.make;
  objFormat.model = campaign.campaignDetail.model;
  objFormat.version = campaign.campaignDetail.version;
  objFormat.logoFrontLeft = campaign.campaignDetail.logoFrontLeft;
  objFormat.vehicleType = campaign.campaignDetail.vehicleType;
  objFormat.currentKilometers = campaign.campaignDetail.currentKilometers;
  objFormat.registrationYear = campaign.campaignDetail.registrationYear;
  objFormat.stock = campaign.campaignDetail.stock;
  objFormat.stockAlert = campaign.campaignDetail.stockAlert;
  objFormat.campaignFactory = campaign.campaignDetail.campaignFactory;
  objFormat.crcGroup = campaign.crcGroup;
  objFormat.car = campaign.car;
  objFormat.originCampaign = campaign.originCampaign;
  objFormat.salePrices = campaign.salePrices ? campaign.salePrices : null;

  objFormat.publishType = campaign.publishType;
  objFormat.termMileageMatrix = campaign.termMileageMatrix;
  objFormat.pricings = campaign.pricings;

  if (campaign.campaignDetail && campaign.campaignDetail.urlPhoto) {
    objFormat.urlPhoto = campaign.campaignDetail.urlPhoto[0];
  }
  return objFormat;
};

export const sortArrayByAttr = (field, attr) =>
  [...field].sort((itemA, itemB) => {
    if (itemA[attr] < itemB[attr]) {
      return -1;
    }
    if (itemA[attr] > itemB[attr]) {
      return 1;
    }
    return 0;
  });

export const areDifferentsListCustomers = (defaultList, selectedList) => {
  const defaultSet = new Set(defaultList.map(obj => obj.id));
  const selectedSet = new Set(selectedList.map(obj => obj.id));
  if (defaultSet.size !== selectedSet.size) return true;
  return ![...defaultSet].every(id => selectedSet.has(id));
};

export const getCustomersSelected = selectedList =>
  selectedList.map(item => ({
    idCustomer: item.idCustomer
  }));

export const moveArrayItemToNewIndex = (arr, fromIndex, toIndex) => {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
  return arr;
};
export const passArrayToObjectSelectOptions = (array, label = '') =>
  array.map(element => ({ label: `${element} ${label}`, value: element }));
